export enum PazaramaOrderStatus {
  CREATED = 'Created',
  CANCELLED = 'Cancelled',
}

export const pazaramaOrderStatusNameMap: Record<PazaramaOrderStatus, string> = {
  [PazaramaOrderStatus.CREATED]: 'Sipariş Oluşturuldu',
  [PazaramaOrderStatus.CANCELLED]: 'İptal Edildi',
};

export const pazaramaOrderStatusDescriptionMap: Record<
  PazaramaOrderStatus,
  string
> = {
  [PazaramaOrderStatus.CREATED]: 'Stok Düşüldü',
  [PazaramaOrderStatus.CANCELLED]: 'Stok Geri Eklendi',
};
